import React, { memo } from "react"
import { Handle, Position, NodeProps } from "@xyflow/react"
import { TriggerNodeData } from "lib/types/workflow"

import { NodeContainer, NodeHeader, NodeBody } from "./TriggerNode.styled"
import {
  StatusBadge,
  FailedMessageBlock,
  statusIcon
} from "./ExecutionOverlay.styled"
import TerminalAddButton from "./TerminalAddButton"

type Props = NodeProps & { id: string; data: TriggerNodeData }

const TriggerNode = memo(({ id, data }: Props) => {
  const showAddButton =
    (data._terminalHandles ?? []).includes("output") && !!data._onAddAtTerminal
  const status = data._executionStatus

  return (
    <NodeContainer $skipped={status === "skipped"}>
      <NodeHeader>Trigger</NodeHeader>
      <NodeBody>{data.label}</NodeBody>
      {data._failedMessage && (
        <FailedMessageBlock>{data._failedMessage}</FailedMessageBlock>
      )}
      <Handle type="source" position={Position.Bottom} id="output" />
      {showAddButton && (
        <TerminalAddButton
          onClick={() => data._onAddAtTerminal?.(id, "output")}
          highlighted={data._activeTerminalDropHandle === "output"}
        />
      )}
      {status && (
        <StatusBadge $status={status}>{statusIcon(status)}</StatusBadge>
      )}
    </NodeContainer>
  )
})

TriggerNode.displayName = "TriggerNode"

export default TriggerNode
